import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {NotificationManager} from "react-notifications";
import {confirm} from "../../../../utils/confirmDialog";
import * as AdminActions from "../../../../actions/admin";
import * as RaceActions from "../../../../actions/race";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class RaceMemberComp extends React.Component {

    static propTypes = {
        race: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            club: props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? props.auth.currentEntity : '',
            selectedToAdd: [],
            selectedToRemove: [],
        };
    }

    componentDidMount() {
        if (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, this.props.auth.currentEntity));
    }

    fields = [];
    render() {
        const pigeonholes = this.props.racePigeons.has(this.props.race.Nr + '/' + this.state.club) ? this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.sort((s1, s2) => s1.Slagnr < s2.Slagnr ? -1 : (s1.Slagnr > s2.Slagnr ? 1 : 0)).toArray() : [];
        return <div className={"form-page race-member-comp"}>
            <div className="top-panel">
                <div className="top-content">
                    <div className="block-content">
                        <table>
                            <tbody>
                            <tr>
                                <td><label className={this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? 'disabled' : ''} htmlFor="club">Forening</label></td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'-- Vælg --'} className="field100p" containerClassName="display-inline-block field100p" disabled={this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id}
                                                      name="club" id="club" value={this.state.club} options={
                                                          this.props.admin.clubs.filter(c =>
                                                              (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id && c.Sektionsnr !== '99') ||
                                                              (this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && c.Sektionsnr === this.props.auth.currentEntity) ||
                                                              (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && c.Foreningsnr === this.props.auth.currentEntity)
                                                          ).sort((c1, c2) => c1.Foreningsnr < c2.Foreningsnr ? -1 : (c1.Foreningsnr > c2.Foreningsnr ? 1 : 0)).map(club => (
                                                              {key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn)}
                                                          )).toArray()
                                                      }
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={e => {
                                                          this.setState({
                                                              club: e.target.value,
                                                              selectedToAdd: [],
                                                              selectedToRemove: [],
                                                          });
                                                          this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, e.target.value));
                                                      }}
                                                      ref={instance => { this.fields[0] = instance; }}
                                    />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="bottom-panel">
                <div id="data-table" className="bottom-content">
                    <div className="block-content">
                        <table className="data-table">
                            <thead>
                            <th scope="row"></th>
                            <th>Slagnr.</th>
                            <th>Slagnavn</th>
                            </thead>
                            <tbody>
                                {pigeonholes.map(pigeonhole => <tr key={pigeonhole.Slagnr} className={!pigeonhole.Slagspil && (this.props.race.SlagspilS === null || this.props.race.SlagspilS === 0) ? 'disabled' : ''} onDoubleClick={() => {
                                    if (pigeonhole.Slagspil || (this.props.race.SlagspilS !== null && this.props.race.SlagspilS !== 0)) {
                                        if (pigeonhole.Slagspil) this.props.dispatch(RaceActions.removeMemberGames(this.props.race.Nr, this.state.club, [pigeonhole.Slagnr], () => {
                                            NotificationManager.success("Slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " er afmeldt slagspil.", "Slagspil", 4000);
                                        })); else this.props.dispatch(RaceActions.addMemberGames(this.props.race.Nr, this.state.club, [pigeonhole.Slagnr], () => {
                                            NotificationManager.success("Slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " er tilmeldt slagspil.", "Slagspil", 4000);
                                        }));
                                    }
                                }}>
                                    <td><input type="checkbox" checked={pigeonhole.Slagspil} onChange={() => {
                                        if (pigeonhole.Slagspil || (this.props.race.SlagspilS !== null && this.props.race.SlagspilS !== 0)) {
                                            if (pigeonhole.Slagspil) this.props.dispatch(RaceActions.removeMemberGames(this.props.race.Nr, this.state.club, [pigeonhole.Slagnr], () => {
                                                NotificationManager.success("Slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " er afmeldt slagspil.", "Slagspil", 4000);
                                            })); else this.props.dispatch(RaceActions.addMemberGames(this.props.race.Nr, this.state.club, [pigeonhole.Slagnr], () => {
                                                NotificationManager.success("Slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " er tilmeldt slagspil.", "Slagspil", 4000);
                                            }));
                                        }
                                    }}/></td>
                                    <td>{pigeonhole.Slagnr}</td>
                                    <td>{pigeonhole.Slagnavn}</td>
                                </tr>)}
                            </tbody>
                        </table>
                        {/* OLD DESIGN: <div className="left-content selection-list">
                            <div className="list-header">Ikke tilmeldte slag</div>
                            <div className="list-content">
                                <table className="clickable">
                                    <tbody>
                                        {pigeonholes.filter(pigeonhole => !pigeonhole.Slagspil).map(pigeonhole => <tr key={pigeonhole.Slagnr} className={this.props.race.SlagspilS === null || this.props.race.SlagspilS === 0 ? 'disabled' : ''} onClick={() => {
                                            if (this.props.race.SlagspilS !== null && this.props.race.SlagspilS !== 0) {
                                                const ix = this.state.selectedToAdd.indexOf(pigeonhole.Slagnr);
                                                if (ix < 0) this.state.selectedToAdd.push(pigeonhole.Slagnr);
                                                else this.state.selectedToAdd.splice(ix, 1);
                                                this.forceUpdate();
                                            }
                                        }}>
                                            <td><input type="checkbox" checked={this.state.selectedToAdd.indexOf(pigeonhole.Slagnr) >= 0}/></td>
                                            <td>{pigeonhole.Slagnr}</td>
                                            <td>{pigeonhole.Slagnavn}</td>
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="center-content">
                            <div className="button-container">
                                <div>
                                    <button className={'btn-primary'} disabled={this.state.selectedToAdd.length < 1} onClick={() => {
                                        this.props.dispatch(RaceActions.addMemberGames(this.props.race.Nr, this.state.club, this.state.selectedToAdd, () => {
                                            NotificationManager.success("De valgte slag er markeret til slagspil.", "Slagspil", 4000);
                                            this.setState({
                                                selectedToAdd: [],
                                                selectedToRemove: this.state.selectedToAdd,
                                            });
                                        }))
                                    }}>Tilføj</button>
                                </div>
                                <div style={{height: '25px'}}/>
                                <div>
                                    <button className={'btn-secondary'} disabled={this.state.selectedToRemove.length < 1} onClick={() => {
                                        this.props.dispatch(RaceActions.removeMemberGames(this.props.race.Nr, this.state.club, this.state.selectedToRemove, () => {
                                            NotificationManager.success("De valgte slag er fjernet fra slagspil.", "Fravalg", 4000);
                                            this.setState({
                                                selectedToAdd: this.state.selectedToRemove,
                                                selectedToRemove: [],
                                            });
                                        }))
                                    }}>Fjern</button>
                                </div>
                            </div>
                        </div>
                        <div className="right-content selection-list">
                            <div className="list-header">Tilmeldte slag</div>
                            <div className="list-content">
                                <table className="clickable">
                                    <tbody>
                                        {pigeonholes.filter(pigeonhole => pigeonhole.Slagspil).map(pigeonhole => <tr key={pigeonhole.Slagnr} onClick={() => {
                                            const ix = this.state.selectedToRemove.indexOf(pigeonhole.Slagnr);
                                            if (ix < 0) this.state.selectedToRemove.push(pigeonhole.Slagnr);
                                            else this.state.selectedToRemove.splice(ix, 1);
                                            this.forceUpdate();
                                        }}>
                                            <td><input type="checkbox" checked={this.state.selectedToRemove.indexOf(pigeonhole.Slagnr) >= 0}/></td>
                                            <td>{pigeonhole.Slagnr}</td>
                                            <td>{pigeonhole.Slagnavn}</td>
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>*/}
                    </div>
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        clubs: state.admin.clubs,
    },
    racePigeons: state.race.racePigeons,
});

export default connect(mapStateToProps, null, null, {withRef: true})(RaceMemberComp);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/race/subPages/RaceMemberComp.js